import { Product, CollectionItem, TradeRequest } from '../types'

const PRODUCTS_KEY = 'osi-use-products'
const COLLECTION_KEY = 'osi-use-collection'
const TRADE_REQUESTS_KEY = 'osi-use-trade-requests'

export function getProducts(): Product[] {
  const data = localStorage.getItem(PRODUCTS_KEY)
  return data ? JSON.parse(data) : []
}

export function saveProduct(product: Omit<Product, 'id' | 'createdAt' | 'updatedAt' | 'seller'>): Product {
  const products = getProducts()
  const now = new Date().toISOString()

  const newProduct: Product = {
    ...product,
    id: crypto.randomUUID(),
    createdAt: now,
    updatedAt: now,
    seller: {
      id: 'demo-user',
      email: 'demo@example.com',
      nickname: 'デモユーザー',
      rating: 4.5,
      reviewCount: 10,
      createdAt: now,
    },
  }

  products.unshift(newProduct)
  localStorage.setItem(PRODUCTS_KEY, JSON.stringify(products))
  return newProduct
}

export function getProductById(id: string): Product | undefined {
  const products = getProducts()
  return products.find(p => p.id === id)
}

export function deleteProduct(id: string): void {
  const products = getProducts().filter(p => p.id !== id)
  localStorage.setItem(PRODUCTS_KEY, JSON.stringify(products))
}

// コレクション関連
export function getCollection(): CollectionItem[] {
  const data = localStorage.getItem(COLLECTION_KEY)
  return data ? JSON.parse(data) : []
}

export function saveCollectionItem(item: Omit<CollectionItem, 'id' | 'createdAt'>): CollectionItem {
  const collection = getCollection()
  const newItem: CollectionItem = {
    ...item,
    id: crypto.randomUUID(),
    createdAt: new Date().toISOString(),
  }
  collection.unshift(newItem)
  localStorage.setItem(COLLECTION_KEY, JSON.stringify(collection))
  return newItem
}

export function updateCollectionItem(id: string, updates: Partial<CollectionItem>): void {
  const collection = getCollection().map(item =>
    item.id === id ? { ...item, ...updates } : item
  )
  localStorage.setItem(COLLECTION_KEY, JSON.stringify(collection))
}

export function deleteCollectionItem(id: string): void {
  const collection = getCollection().filter(item => item.id !== id)
  localStorage.setItem(COLLECTION_KEY, JSON.stringify(collection))
}

export function getTradeableItems(): CollectionItem[] {
  return getCollection().filter(item => item.isTradeAvailable)
}

// 交換依頼関連
export function getTradeRequests(): TradeRequest[] {
  const data = localStorage.getItem(TRADE_REQUESTS_KEY)
  return data ? JSON.parse(data) : []
}

export function createTradeRequest(request: Omit<TradeRequest, 'id' | 'status' | 'createdAt'>): TradeRequest {
  const requests = getTradeRequests()
  const newRequest: TradeRequest = {
    ...request,
    id: crypto.randomUUID(),
    status: 'pending',
    createdAt: new Date().toISOString(),
  }
  requests.unshift(newRequest)
  localStorage.setItem(TRADE_REQUESTS_KEY, JSON.stringify(requests))
  return newRequest
}

export function updateTradeRequest(id: string, status: 'accepted' | 'rejected'): void {
  const requests = getTradeRequests().map(req =>
    req.id === id ? { ...req, status } : req
  )
  localStorage.setItem(TRADE_REQUESTS_KEY, JSON.stringify(requests))
}

export function deleteTradeRequest(id: string): void {
  const requests = getTradeRequests().filter(req => req.id !== id)
  localStorage.setItem(TRADE_REQUESTS_KEY, JSON.stringify(requests))
}
